(function () {
  const desktop = window.matchMedia('(min-width: 990px)');

  document.querySelectorAll('.split-sticky-grid').forEach((root) => {
    if (root.dataset.pairInit) return;
    root.dataset.pairInit = '1';

    const highlight = (idx) => {
      clear();
      if (!idx) return;
      const label = root.querySelector(`.ssg-card[data-marker="${idx}"] .ssg-card__label`);
      const li    = root.querySelector(`.ssg-nested-list li[data-marker="${idx}"]`);
      if (label) label.classList.add('is-highlighted');
      if (li)    li.classList.add('is-highlighted');
    };

    const clear = () => {
      root.querySelectorAll('.ssg-card__label.is-highlighted, .ssg-nested-list li.is-highlighted')
          .forEach((el) => el.classList.remove('is-highlighted'));
    };

    root.addEventListener('mouseover', (e) => {
      if (!desktop.matches) return;
      const card = e.target.closest('.ssg-card[data-marker]');
      if (card && root.contains(card)) return highlight(card.getAttribute('data-marker'));
      const li = e.target.closest('.ssg-nested-list li[data-marker]');
      if (li && root.contains(li)) return highlight(li.getAttribute('data-marker'));
    });

    root.addEventListener('mouseout', (e) => {
      if (!desktop.matches) return;
      if (!root.contains(e.relatedTarget)) clear();
    });

    root.addEventListener('focusin', (e) => {
      if (!desktop.matches) return;
      const t = e.target.closest('.ssg-card[data-marker], .ssg-nested-list li[data-marker]');
      if (t) highlight(t.getAttribute('data-marker'));
    });
    root.addEventListener('focusout', (e) => {
      if (!desktop.matches) return;
      if (!root.contains(e.relatedTarget)) clear();
    });
  });
})();
